<template>
<div class="program_container">
    <div class="back_btn" @click='back'></div>
    <div class="close_btn" @click='close'></div>
    <div ref="wrapper" style="height: 100%;width: 100%;overflow: auto;box-sizing: border-box;padding: 20px;">
        <div style="width: 60%;margin: 0 auto;padding-top: 100px;line-height: 24px;letter-spacing: 1px;">
            <div style="text-indent: 2em;">根据监管要求，第一次使用程序化交易软件需向所开户的期货公司报告，期货公司确认审核通过后才可下单。</div>
            <div style="text-indent: 2em;">*如有多个资金账号需分别向多个期货公司报告。</div>
            <br>
            <div style="margin-bottom: 10px;font-weight: bold;margin-left: 2em;">报告方式</div>
            <div style="margin-bottom: 5px;margin-left: 3px;">1、直接联系期货公司报告使用程序化软件(推荐)。</div>
            <div style="margin-left: 3px;">2、登录{{ productName }}软件向期货公司报告({{ companyTxt }})。</div>
               <div style="margin-left: 27px;">报告路径：{{ softwarePath }}</div>
            <br>
            <div style="text-align: center;margin-top: 35px;">
                <normal-button :disabled="time > 0" style="height: 30px;padding: 0 15px;" @click="finish => {finish(); skip()}">以上我已知晓，下一步<span style="margin-left: 5px;" v-show="time > 0">({{time}}秒)</span></normal-button>
            </div>
        </div>
        <!-- <div v-show="!showMain">
            <div style="width: 60%;margin: 0 auto;padding-top: 100px;">
                <div style="line-height: 30px;text-indent: 2em;">
                    根据监管要求，第一次使用程序化交易软件需向所开户的期货公司报告，期货公司确认审核通过后才可下单。
                    <br>
                    <div style="text-indent: 2em;">*如有多个资金账号需分别向多个期货公司报告</div>
                </div>
                <br>
                <br>
                <el-button type="text" @click="skip">>>>我已知晓，跳过报告，直接去付款。</el-button>
                <br>
                <div style="border-top: 1px solid #e0e0e0;padding-top: 30px;margin-top: 25px;min-height: 42px;line-height: 35px;">请填写去报告的期货公司：
                    <el-tag v-for="(tag, index) in potentialCompany" :key="tag.name" style="margin-right: 10px;margin-bottom: 10px;" closable @close="userRemove(index)">
                        {{tag.name}}
                    </el-tag>
                </div>
                <el-select v-model="userSelect" size="small" placeholder="选择添加期货公司" filterable @change="userSelectChange" style="width: 200px;margin-top: 10px;">
                    <el-option v-for="item in tableData" :label="item.name" :value="item.id" :key="item.id" />
                </el-select>
                <div style="margin-top: 50px;text-align: center;">
                    <el-button type="text" v-if="potentialState == 1" @click="userConfirm(() => {})">>>>去向{{potentialCompanyNames}}报告</el-button>
                    <normal-button v-else v-show="potentialCompany.length > 0" style="height: 30px;width: 60px;" @click="userConfirm">确定</normal-button>
                </div>

            </div>
        </div>
        <div v-show="showMain">
            <div v-for="(el, index) in accounts" :key="index">
                <h3 class="page_title">期货市场程序化交易客户信息报告表 - {{getCompanyName(el.companyid)}}</h3>
                <el-card class="page_card" style="width: 100%;" shadow="never">
                    <template #header>
                        <div class="card-header">
                            <span>基本信息</span>
                        </div>
                    </template>
                        <el-form class="page_form" label-width="190px" size="small">
                            <el-form-item class="form_item">
                                <template slot="label"><span class="star">*</span>开户的期货公司</template>
                                {{getCompanyName(el.companyid)}}
                            </el-form-item>
                            <el-form-item class="form_item" label-width="140px">
                                <template slot="label"><span class="star">*</span>资金账号</template>
                                <el-input v-model="el.account" placeholder="请确保信息准确" clearable />
                            </el-form-item>
                            <el-form-item class="form_item">
                                <template slot="label"><span class="star">*</span>报告人姓名/报告机构名称</template>
                                <el-input v-model="el.form.userName" @change="useNameChange($event, el)" placeholder="" clearable />
                            </el-form-item>
                            <el-form-item class="form_item" label-width="140px">
                                <template slot="label"><span class="star">*</span>联系电话</template>
                                <el-input v-model="el.form.phone" placeholder="" clearable @change="phoneChange($event, el)"/>
                            </el-form-item>
                        </el-form>
                    
                </el-card>
                <el-card class="page_card" style="width: 100%;border-top: 0;" shadow="never">
                    <template #header>
                        <div class="card-header">
                            <span>交易所信息</span>
                        </div>
                    </template>
                    <div class="exchange_list" shadow="hover" v-for="(item, index) in el.form.exchange" :key="index">
                        <div class="selector">
                            <el-checkbox v-model="item.selected" style="position: relative;top: 7px;"></el-checkbox>
                        </div>
                        <div style="flex: 1;">
                            <el-form class="page_form" size="small" label-width="180px">
                                <div style="height: 33px;margin-bottom: 18px;float: left;line-height: 33px;width: 84px;">
                                    {{exchangeEnum[item.name]}}
                                </div>
                                <el-form-item label-width="90px" class="form_item" style="padding-left: 10px;width: 220px;">
                                    <template slot="label"><span class="star">*</span>编码类型:</template>
                                    <el-select v-model="item.codeType" placeholder="" multiple collapse-tags>
                                        <el-option label="交易" :value="0" />
                                        <el-option label="套保" :value="1" />
                                        <el-option label="套利" :value="2" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="客户交易编码:" label-width="100px" class="form_item" style="width:200px;padding-left: 20px;">
                                    <el-input v-model="item.code" placeholder="" clearable />
                                </el-form-item>
                                
                                <el-form-item label="程序化交易软件:" label-width="120px" class="form_item" style="width:160px;padding-left:20px;">
                                    {{item.softwareName}}
                                </el-form-item>
                                <div style="float: left;height: 33px;margin-bottom: 18px;" v-if="!item.more"><el-button type="text" @click="item.more = true" style="padding-top: 0;padding-bottom: 0;line-height: 28px;">查看详情</el-button></div>
                                <el-form-item label="程序化交易软件开发主体" class="form_item" v-show="item.more" label-width="166px" style="width: 100%;padding-left: 0;">
                                    {{item.softwareMain}}
                                </el-form-item>
                                <el-form-item label="程序化交易软件基本功能" class="form_item" v-show="item.more" label-width="166px" style="width: 100%;padding-left: 0;">
                                    <el-select v-model="item.softwareFunction" placeholder="" @change="val => {if (!val.includes(8)) item.softwareFunctionIntro = ''}" multiple collapse-tags :max-collapse-tags="3">
                                        <el-option disabled label="自动开/平仓 " :value="0" />
                                        <el-option disabled label="止盈/止损功能" :value="1" />
                                        <el-option disabled label="批量下单" :value="2" />
                                        <el-option disabled label="多账户管理" :value="3" />
                                        <el-option disabled label="套利/组合套利" :value="4" />
                                        <el-option disabled label="交易模型编写" :value="5" />
                                        <el-option disabled label="一键/快捷下单" :value="6" />
                                        <el-option disabled label="日内短线" :value="7" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="交易指令执行方式" class="form_item title_left" v-show="item.more" label-width="166px" style="width: 100%;padding-left: 0;">
                                    <el-select v-model="item.executionMode" placeholder="" @change="val => {if (!val.includes(2)) item.executionModeIntro = ''}" multiple collapse-tags :max-collapse-tags="3">
                                        <el-option disabled label="自动下单" :value="0" />
                                        <el-option disabled label="手动下单" :value="1" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="是否终止" class="form_item title_left" v-show="item.more" label-width="166px" style="width: 100%;padding-left: 0;">
                                    <el-radio-group v-model="item.stop" disabled>
                                        <el-radio :label="1">是</el-radio>
                                        <el-radio :label="0">否</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </el-card>
            </div>
            <div class="flex_center" style="margin-top: 40px;">
                <normal-button class="page_btn" @click="submit" style="height: 30px;">提交</normal-button>
            </div>
            <div class="page_tips">
                <h4>应当履行程序化交易报告义务的交易者范围</h4>
                <p>交易者在交易所的交易符合以下条件之一的，应当履行报告义务:</p>
                <p>1.在1个交易日内出现10次(含)以上1秒钟内10笔(含)以上报撤单的，实际控制关系账户组的报撤单笔数按照单个客户执行；</p>
                <p>2.合约代码、买卖方向、委托数量、委托价格等交易指令核心要素以及交易指令的下达时间均由计算机自动决定的；</p>
                <p>3.使用自主研发或者其他定制程序化交易软件的；</p>
                <p>4.交易所认定的其他需要报告的情形。</p>
            </div>
        </div> -->
    </div>
</div>
    
</template>

<script>
import axios from 'axios'
import CryptoJS from 'crypto-js'
import icon from '../assets/image/th.png'

const KEY = 'cGNld2Via2V5cGR5bWNkZWltYWRtaW5jb25maXJtY2Q='
const IV = 'UEpBSUowPT0xMzROSksxMw=='

const encrypt = (word, keyStr, ivStr) => {
    word = typeof word === 'object' ? JSON.stringify(word) : word;

    keyStr = keyStr ?? atob(KEY); //判断是否存在ksy，不存在就用定义好的key
    ivStr = ivStr ?? atob(IV);

    // 字符串类型的key用之前需要用uft8先parse一下才能用
    const key = CryptoJS.enc.Utf8.parse(keyStr);
    const iv = CryptoJS.enc.Utf8.parse(ivStr);

    const srcs = CryptoJS.enc.Utf8.parse(word);
    const encrypted = CryptoJS.AES.encrypt(srcs, key,
        {
            iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
    return encrypted.toString();
}
function hasDuplicatesObject(arr) {
  if (!Array.isArray(arr)) {
    throw new Error('输入必须是一个数组');
  }

  const seen = {}; // 用于存储已见过的数字

  for (const obj of arr) {
    // 检查数字是否已经在对象中
    if (seen[obj.id]) {
      return true; // 找到重复项
    }
    // 将数字添加到对象中，标记为已见过
    seen[obj.id] = true;
  }

  return false; // 遍历完都没有重复
}
export default {
    name: 'program-apply',
    inject: ['appOverFlow', 'popOverShow', 'programApplyShow'],
    data: () => ({
        tableData: [
            {
                id: 999,
                name: '期货公司A',
                ip: 'https://cxhtest.wenhua.com.cn:5443/client1',
            },
            {
                id: 998,
                name: '期货公司B',
                ip: 'https://cxhtest.wenhua.com.cn:5443/client2'
            },
            {
                id: 3,
                name: '测试三（客户端交互测试）',
                ip: 'https://cxhtest.wenhua.com.cn:5443/client1',
                requestType: 1,
                tcp: '172.16.9.14',
                port: '9901'
            }
        ],
        userSelect: '',
        potentialCompany: [],
        exchangeEnum: {
            "大连商品交易所": "大商所DCE",
            "郑州商品交易所": '郑商所CZCE',
            "上海期货交易所": "上期所SHFE",
            "中国金融期货交易所": "中金所CFFEX",
            "上海国际能源交易中心": "上期能源IE",
            "广州期货交易所": "广期所GFEX"
        },
        accounts: [
            
        ],
        showMain: true,
        time: 3,
        timer: null
    }),
    computed: {
        appid () {
            if ([1,122].includes(this.$store.state.Order.submitData?.productId)) return '11'
            if ([124].includes(this.$store.state.Order.submitData?.productId)) return '17'
            return ''
        },
        companyList () {
            let is_wh7 = [76, 123].includes(this.$store.state.Order.submitData?.productId)
            return this.tableData.filter(v => v.ip != '' && (is_wh7 ? v.wh7 : true))
        },
        potentialState () {
            if (this.potentialCompany.every(v => this.companyList.some(el => el.id == v.id))) return 3
            else if (this.potentialCompany.every(v => !this.companyList.some(el => el.id == v.id))) return 2
            else if (this.potentialCompany.some(v => this.companyList.some(el => el.id == v.id))) return 1
        },
        potentialCompanyNames () {
            return this.potentialCompany.filter(v => this.companyList.some(el => el.id == v.id)).map(v => this.companyList.find(el => el.id == v.id).name).join('、')
        },
        productName () {
            if ([1,122, 124].includes(this.$store.state.Order.submitData?.productId)) return 'WT8/WT9'
            if ([76, 123].includes(this.$store.state.Order.submitData?.productId)) return 'wh7'
            return ''
        },
        softwarePath () {
            if ([1,122, 124].includes(this.$store.state.Order.submitData?.productId)) return '软件菜单 量化->程序化报备'
            if ([76, 123].includes(this.$store.state.Order.submitData?.productId)) return '软件菜单 系统工具->程序化报备'
            return ''
        },
        companyTxt () {
            if ([1,122, 124].includes(this.$store.state.Order.submitData?.productId)) return `支持${this.companyList.length}家期货公司`
            if ([76, 123].includes(this.$store.state.Order.submitData?.productId)) return '仅支持wh7列表中的期货公司'
            return ''
        }
    },
    methods: {
        skip () {
            this.$emit('pay')
        },
        close () {
            this.popOverShow(false)
            this.programApplyShow(false)
            this.appOverFlow('auto')
            this.clear()
        },
        back () {
            this.$emit('back')
        },
        nextStep () {
            
            this.accounts = this.potentialCompany.filter(v => this.tableData.find(el => el.id == v.id).ip != '').map(v => ({
                accont: '',
                companyid: v.id,
                form: {
                    id: 0,
                    phone: '',
                    userName: '',
                    account: '',
                    userType: null,
                    contactName: '',
                    contactTel: '',
                    chargeName: '',
                    chargeTel: '',
                    manager: '不涉及',
                    exchange: [
                        {
                            id: 0,
                            codeType: [0],
                            code: '',
                            softwareName: this.appid == '11' ? 'WT8' : 'WT9',
                            otherSoftwareName: '',
                            softwareMain: '星格量化投资技术研究所（苏州）有限公司',
                            softwareFunction: this.getDefaultFunction(),
                            softwareFunctionIntro: '',
                            executionMode: [0, 1],
                            executionModeIntro: '',
                            stop: 0,
                            name: '郑州商品交易所',
                            selected: true,
                            more: false
                        },
                        {
                            id: 0,
                            codeType: [0],
                            code: '',
                            softwareName: this.appid == '11' ? 'WT8' : 'WT9',
                            otherSoftwareName: '',
                            softwareMain: '星格量化投资技术研究所（苏州）有限公司',
                            softwareFunction: this.getDefaultFunction(),
                            softwareFunctionIntro: '',
                            executionMode: [0, 1],
                            executionModeIntro: '',
                            stop: 0,
                            name: '大连商品交易所',
                            selected: true,
                            more: false
                        },
                        {
                            id: 0,
                            codeType: [0],
                            code: '',
                            softwareName: this.appid == '11' ? 'WT8' : 'WT9',
                            otherSoftwareName: '',
                            softwareMain: '星格量化投资技术研究所（苏州）有限公司',
                            softwareFunction: this.getDefaultFunction(),
                            softwareFunctionIntro: '',
                            executionMode: [0, 1],
                            executionModeIntro: '',
                            stop: 0,
                            name: '上海期货交易所',
                            selected: true,
                            more: false
                        },
                        {
                            id: 0,
                            codeType: [0],
                            code: '',
                            softwareName: this.appid == '11' ? 'WT8' : 'WT9',
                            otherSoftwareName: '',
                            softwareMain: '星格量化投资技术研究所（苏州）有限公司',
                            softwareFunction: this.getDefaultFunction(),
                            softwareFunctionIntro: '',
                            executionMode: [0, 1],
                            executionModeIntro: '',
                            stop: 0,
                            name: '中国金融期货交易所',
                            selected: true,
                            more: false
                        },
                        {
                            id: 0,
                            codeType: [0],
                            code: '',
                            softwareName: this.appid == '11' ? 'WT8' : 'WT9',
                            otherSoftwareName: '',
                            softwareMain: '星格量化投资技术研究所（苏州）有限公司',
                            softwareFunction: this.getDefaultFunction(),
                            softwareFunctionIntro: '',
                            executionMode: [0, 1],
                            executionModeIntro: '',
                            stop: 0,
                            name: '上海国际能源交易中心',
                            selected: true,
                            more: false
                        },
                        {
                            id: 0,
                            codeType: [0],
                            code: '',
                            softwareName: this.appid == '11' ? 'WT8' : 'WT9',
                            otherSoftwareName: '',
                            softwareMain: '星格量化投资技术研究所（苏州）有限公司',
                            softwareFunction: this.getDefaultFunction(),
                            softwareFunctionIntro: '',
                            executionMode: [0, 1],
                            executionModeIntro: '',
                            stop: 0,
                            name: '广州期货交易所',
                            selected: true,
                            more: false
                        },
                    ],
                },
            }))
            this.showMain = true
        },
        userRemove (index) {
            this.potentialCompany.splice(index, 1)
        },
        userSelectChange (val) {
            this.userSelect = ''
            if (this.potentialCompany.some(v => v.id == val)) return
            let company = this.tableData.find(v => v.id == val)
            this.potentialCompany.push({id: val, name: company.name})
        },
        userConfirm (finish) {
            if (this.potentialCompany.length == 0) {
                return this.$market.orderAlert({
                            content: '请选择期货公司',
                            confirmCall() {
                                finish && finish()
                            }
                        })
            } 
            if (hasDuplicatesObject(this.potentialCompany)) return this.$market.orderAlert({
                content: '您选择的期货公司有重复，请确认后再提交。',
                confirmCall() {
                    finish && finish()
                }
            })
            if (this.potentialState == 2) {
                this.$market.orderAlert({
                    content: `<img src="${icon}" style="position: relative;top: 5px;margin-right: 5px;"/>请向期货公司报告使用程序化软件。`,
                    btnTxt: '确定，去付款',
                    closeBtn: true,
                    closeCall: () => {
                        finish && finish()
                    },
                    confirmCall:() => {
                        finish && finish()
                        this.skip()
                    }
                })
            } else {
                finish && finish()
                this.nextStep()
            }
        },
        getDefaultFunction () {
            if (this.appid == '11') return [0, 1, 3, 5, 6]
            else if (this.appid == '17') return [0, 1, 3, 4, 5, 6]
            return []
        },
        phoneChange (val, obj) {
            obj.form.contactTel = val
            obj.form.chargeTel = val
        },
        useNameChange (val, obj) {
            if (val) {
                obj.form.chargeName = val
            } else {
                obj.form.chargeName = '程序化使用人'
            }
            obj.form.contactName = val
        },
        clear () {
            if (this.$store.state.Order.submitData.identityType != 2) {
                this.skip()
            }
            this.time = 3
            this.timer && clearInterval(this.timer)
            this.timer = setInterval(() => {
                if (this.time > 0) this.time--
            }, 1000)
            this.$refs.wrapper && (this.$refs.wrapper.scrollTop = 0)
            if (this.$store.state.Order.submitData.identityType == 2) {
                this.showMain = false
            }
            this.accounts = []
            this.userSelect = ''
            this.potentialCompany = []
        },
        async submit (finish, load) {
            finish()
            if (this.tableData.length <= 0) return this.$alert('该功能期货公司正在建设中...', '提示', { confirmButtonText: '确定',})
            if (this.accounts.some(v => v.account === '')) return this.$message({type: 'warning', message: '请填写资金账号'})
            if (this.accounts.some(v => v.companyid === '')) return this.$message({type: 'warning', message: '请选择开户期货公司'})
            if (this.accounts.some(v => v.form.userName == '')) return this.$message({type: 'warning', message: '请填写客户名称'})
            if (this.accounts.some(v => v.form.phone == '')) return this.$message({type: 'warning', message: '请填写联系电话'})
            if (this.accounts.some(v => v.form.exchange.filter(v => v.selected).some(v => !v.codeType || v.codeType.length == 0))) return this.$message({type: 'warning', message: '请选择编码类型'})
            load()
            await Promise.all(this.accounts.map(v => new Promise(async (resolve, reject) => {
                let company = this.tableData.find(el => el.id == v.companyid)
                let data = {
                    "id": 0,
                    "hqzh": this.$store.state.Order.submitData?.xzh || '',
                    "orderPhone": v.form.phone || this.$store.state.Order.submitData.phone,
                    "customerName": v.form.userName,
                    "customerType": v.form.userType,
                    "contactPerson": v.form.contactName,
                    "contactPhone": v.form.contactTel,
                    "superintendents": v.form.chargeName,
                    "superintendentsPhone": v.form.chargeTel,
                    "managerName": v.form.manager,
                    "whid": v.account,
                    "appid": this.appid,
                    "qhgsid": v.companyid,
                    "subList": v.form.exchange.filter(obj => obj.selected).map(obj => ({
                        "qhgsid": 0,
                        "whid": '',
                        "customerId": obj.id,
                        "exchange": obj.name,
                        "exchangeNo": 0,
                        "exchangeNoStr": obj.codeType.join(','),
                        "transactionNo": obj.code,
                        "softwareName": obj.softwareName,
                        "otherSoftwareName": "",
                        "softwareMan": obj.softwareMain,
                        "softwareGn": obj.softwareFunction.join(','),
                        "otherSoftwareGn": obj.softwareFunctionIntro,
                        "tradeOrder": obj.executionMode.join(','),
                        "otherTradeOrder": obj.executionModeIntro,
                        "isEnd": obj.stop ? true : false
                    }))
                }
                if (company.ip) {
                    let res = await axios({
                        method: 'post',
                        url: company.ip + '/api/Customer/CreateCustomer',
                        data: { param: encrypt(data) }
                    })
                    finish()
                    if (res.data.success) {
                        this.$message({type: 'success', message: res.data.message})
                        await this.sendMessage(data, company.ip)
                        resolve()
                    } else {
                        this.$message({type: 'error', message: res.data.message})
                        reject()
                    }
                } else {
                    // await this.sendMessage(data)
                    finish()
                    resolve()
                }
            })))
            this.skip()
            
        },
        async sendMessage (data, ip = '') {
            await axios({
                method: 'post',
                url: 'https://wh-api.wenhua.com.cn/api/Customer/AddCustomer',
                data: {
                    ...data,
                    dzh: this.$store.state.Order.submitData?.dzh || '',
                    xzh: this.$store.state.Order.submitData?.xzh || '',
                    domainName: ip
                }
            })
        },
        async getCompanyList () {
            let res = await axios({
                url: 'https://wenhua-assets.wenhua.com.cn/ztsys/cxh_company.json'
            })
            this.tableData = [
                ...res.data
            ]
        },
        getCompanyName (id) {
            return this.tableData.find(v => v.id == id)?.name
        },
        add () {
            this.accounts.push({
                accont: '',
                companyid: ''
            })
        },
        del (index) {
            this.accounts.splice(index, 1)
        }
    },
    created () {
        
        this.getCompanyList()
        this.clear()
    }
}
</script>

<style scoped>
.back_btn {
    position: absolute;
    left: 20px;
    top: 14px;
    width: 30px;
    height: 30px;
}
.back_btn::before{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 15px;
    height: 2px;
    background-color: #666;
    transform: rotate(-45deg);
}
.back_btn::after{
    content: '';
    position: absolute;
    top: 10px;
    left: 0;
    width: 15px;
    height: 2px;
    background-color: #666;
    transform: rotate(45deg);
}
.back_btn:hover::before,.back_btn:hover::after{
    background-color: #aaa;
}
.close_btn {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 20px;
    top: 10px;
    z-index: 100;
}

.close_btn::before {
    content: '';
    width: 25px;
    height: 2px;
    background-color: rgb(53, 59, 63);
    position: absolute;
    top: 10px;
    left: 0;
    transform: rotate(45deg);
}

.close_btn::after {
    content: '';
    width: 25px;
    height: 2px;
    background-color: rgb(53, 59, 63);
    position: absolute;
    top: 10px;
    left: 0;
    transform: rotate(-45deg);
}

.close_btn:hover::before,
.close_btn:hover::after {
    background-color: #999;
}
.program_container {
    position: fixed;
    width: 925px;
    right: 0;
    transform: translateX(0%);
    top: 0;
    bottom: 0;
    background: url(../assets/image/bg_03.jpg) repeat;
    overflow: auto;
    box-shadow: -3px 0 5px 0px #888;
    z-index: 1001;
    padding: 33px 0 10px 20px;
    box-sizing: border-box;
    font-size: 14px;
    transition: all 0.5s;
    user-select: none;
}
.form_item {
    width: calc(50% - 20px);
    padding-left: 20px;
    float: left;
}
.flex_center {
    display: flex;
    justify-content: center;
}
.exchange_list {
    width: 100%;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
    border-bottom: 1px solid #f4f4f4;
    display: flex;
}
.exchange_list .selector {
    flex: 0 30px;
    width: 30px;
}
.exchange_list_all {
    width: 100%;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
}
.exchange_list_all .selector {
    flex: 0 30px;
    width: 30px;
}
.page_title {
    font-size: 15px;
    color: #666;
    cursor: default;
}
.page_title::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 14px;
    vertical-align: middle;
    background-color: #397eb9;
    margin-right: 10px;
}
.page_table {
    table-layout: fixed;
    width: 100%;
    border: 1px solid #e5e5e5;
    padding-top: 1px;
    background-color: white;
    font-size: 14px;
}
.page_table td {
    padding: 10px;
    text-align: center;
    border: 1px solid white;
    cursor: default;
}
.page_table thead {
    background-color: #eef7ff;
    color: #666;
}
.page_table tbody tr.active {
    background-color: #f8f8f8;
}
.page_table tbody tr:hover {
    background-color: #f8f8f8;
}
.page_table tbody tr:hover td {
    border-color: #f8f8f8;
}
.page_card {
    border-radius: 0;
}
.page_card >>> .el-card__header {
    border-bottom: 0;
    padding: 10px;
    font-size: 14px;
    background-color: #eef7ff;
}
.page_pagination >>> .el-pagination.is-background .btn-next {
    background-color: white;
}
.page_pagination >>> .el-pagination.is-background .btn-prev {
    background-color: white;
}
.page_pagination >>> .el-pagination.is-background .el-pager li {
    background-color: white;
}
.page_pagination >>> .el-pagination.is-background .el-pager li.is-active {
    background-color: #409eff;
}
.page_form {
    overflow: hidden;
}
.page_form >>> .el-form-item__label {
    font-size: 14px;
}
.add_info {
    font-size: 14px;
    color: #3779bc;
}
.add_info .add_icon {
    color: #3779bc;
}
.add_info .add_icon:hover {
    color: #93b7dd;
}
.page_btn {
    padding: 5px 40px;
    display: inline-block;
    font-size: 15px;
    color: white;
}
.page_btn.reset {
    background-color: #999;
    margin-left: 20px;
}
.page_btn.reset:hover {
    background-color: #aaa;
}
.page_tips h4{
    font-size: 14px;
    margin: 0;
    margin-bottom: 5px;
}
.page_tips p {
    font-size: 14px;
    margin: 0;
    margin-bottom: 5px;
}
.page_tips {
    margin-top: 40px;
}
.star {
    color: #f56c6c;
    font-size: 14px;
    margin-right: 3px;
}
.title_left >>> .el-form-item__label {
    text-align: left;
}
</style>